var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5951 14.1081C5.39409 14.1081 5.19308 14.0311 5.03995 13.878L0.230343 9.06826C-0.0767811 8.76128 -0.0767811 8.26493 0.230343 7.95795C0.537324 7.65097 1.03353 7.65097 1.34065 7.95795L5.5951 12.2124L14.6594 3.1482C14.9664 2.84122 15.4626 2.84122 15.7697 3.1482C16.0767 3.45533 16.0767 3.95153 15.7697 4.25865L6.1504 13.878C5.99726 14.0311 5.79611 14.1081 5.5951 14.1081Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicks);
export default __webpack_public_path__ + "static/media/ticks.a86cf47d69c105be37587286b1b189a5.svg";
export { ForwardRef as ReactComponent };